export default function stop() {
    return 'stop'
}